import ContentCopyRoundedIcon from "@mui/icons-material/ContentCopyRounded";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import PublicRoundedIcon from "@mui/icons-material/PublicRounded";

import { ShareMenu, type ShareMenuItem } from "../../components/share/ShareMenu.js";
import { toast } from "../../components/ui/use-toast.js";
import {
  folderMailtoHref,
  folderPortalUrl,
  folderStaffUrl,
  triggerMailto,
  type ShareableFolder,
} from "./shareLinks.js";

function copy(url: string, what: string): void {
  void navigator.clipboard
    ?.writeText(url)
    .then(() => toast({ title: "Link copied", description: `${what} copied to clipboard.` }));
}

/** The folder share actions (2026-09-23), pure so they unit-test. The
 * customer-portal link is offered only for a folder published to customers —
 * a link a customer cannot open is worse than no link. */
export function buildFolderShareItems(folder: ShareableFolder): ShareMenuItem[] {
  const items: ShareMenuItem[] = [
    {
      key: "copy-staff",
      label: "Copy link",
      icon: <ContentCopyRoundedIcon fontSize="small" />,
      testId: "folder-share-copy",
      onClick: () => copy(folderStaffUrl(folder), "Folder link"),
    },
  ];
  if (folder.visible_in_customer_portal) {
    items.push({
      key: "copy-portal",
      label: "Copy customer portal link",
      icon: <PublicRoundedIcon fontSize="small" />,
      testId: "folder-share-copy-portal",
      onClick: () => copy(folderPortalUrl(folder), "Customer portal link"),
    });
  }
  items.push({
    key: "email",
    label: "Share via email",
    icon: <EmailOutlinedIcon fontSize="small" />,
    testId: "folder-share-email",
    onClick: () => triggerMailto(folderMailtoHref(folder)),
  });
  return items;
}

/** "Share folder" button for a folder or sub-folder page. */
export function FolderShareMenu({ folder }: { folder: ShareableFolder }): JSX.Element {
  return <ShareMenu items={buildFolderShareItems(folder)} label="Share folder" />;
}
